import clsx from "clsx";
import { useCallback, useState } from "react";

import type { AccordionsWithImagesType } from "@features/article-content/model/types";

import { Heading } from "@shared/ui/typography";

import { Accordion } from "./accordion";

import s from "./accordion-with-image.module.scss";

export const AccordionWithImage = (props: AccordionsWithImagesType) => {
  const { title, accordion = [] } = props;

  const [activeAccordion, setActiveAccordion] = useState<number | null>(
    accordion?.[0]?.id ?? null,
  );

  const handleOpenAccordion = useCallback((id: number) => {
    setActiveAccordion((prev) => (prev === id ? null : id));
  }, []);

  return (
    <div className={clsx(s.root)}>
      {title && (
        <Heading level={4} className={s.title}>
          {title}
        </Heading>
      )}
      <div className={s.accordions}>
        {accordion?.length > 0 &&
          accordion.map((item, index) => (
            <Accordion
              key={item?.title ?? item?.id ?? index}
              data={item}
              index={index}
              isOnceOpen
              activeAccordion={activeAccordion}
              onAccordionClick={handleOpenAccordion}
            />
          ))}
      </div>
    </div>
  );
};

AccordionWithImage.displayName = "AccordionWithImage";
